<!-- KYMW4600 タグ管理 -->
<div class="contents-area">
  <div class="split_two_part">
    <div>
      <h2>新規タググループ登録</h2>
      <div class="column-list">
        <label class="list-input-title">タググループ名</label>
        <div class="list-input-content">
          <input #txt_NewTagGroup id="txt_NewTagGroup" class="text-label-required" [style.width.rem]="32" type="text"
            plessInputTextSub [fullOnly]="true" [(ngModel)]="newTagGroupName" maxlength="30" [tabindex]="0"
            [restrict]="'[ -￮]'">
          <button #btn_NewTagGroup id="btn_NewTagGroup" class="btn-secondary" (click)="addNewGroup()"
            [tabindex]="0">タググループ追加</button>
        </div>
      </div>
    </div>
    <div>
      <h2>新規タグ登録</h2>
      <div class="column-list">
        <label class="list-input-title">タグ名</label>
        <div class="list-input-content">
          <input #txt_NewTag id="txt_NewTag" class="text-label-required" [style.width.rem]="32" type="text"
            plessInputTextSub [fullOnly]="true" [(ngModel)]="newTagName" maxlength="30" [tabindex]="0"
            [restrict]="'[ -￮]'">
          <button #btn_NewTag id="btn_NewTag" class="btn-secondary" (click)="addNewTag()" [tabindex]="0">タグ追加</button>
        </div>
      </div>
    </div>
  </div>

  <div class="split_two_part">
    <div>
      <h2>タググループ一覧</h2>
      <!-- FlexGrid -->
      <div class="element-column">
        <label>&#8251;タググループに設定されていないタグは使用できません。</label>
        <wj-flex-grid #dtg_TagGroupList class="left-grid" [itemsSource]="model.tagGroupListForEdit"
          [allowDragging]="'None'" horizontalScrollPolicy="on" [headersVisibility]="'Column'" [selectionMode]="'Row'"
          verticalScrollPolicy="on" [allowSorting]="false" [autoRowHeights]="true" [tabindex]="0">
          <wj-flex-grid-filter #fltr_TagGroupList></wj-flex-grid-filter>
          <!-- column チェックボックス -->
          <wj-flex-grid-column [header]="' '" [width]="40" [binding]="'check'" [align]="'center'" [isReadOnly]="true" [minWidth]="5">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="checkbox" class="selected" [(ngModel)]="cell.item.check" (click)="$event.stopPropagation()"
                [tabindex]="-1" />
            </ng-template>
          </wj-flex-grid-column>
          <!-- column タググループ名 -->
          <wj-flex-grid-column [header]="'タググループ名'" [width]="338" [binding]="'tagGroupName'"
            [isReadOnly]="true" [minWidth]="5"></wj-flex-grid-column>
          <!-- column 設定済みのタグ -->
          <wj-flex-grid-column [header]="'設定済みのタグ'" [width]="536" [binding]="'tagNames'" [isReadOnly]="true"
            [allowResizing]="true" [minWidth]="5">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <ng-template ngFor let-item [ngForOf]="cell.item.tags" let-i="index">
                <div class="chip">
                  {{item.tagName}}
                  <span class="closebtn" (click)="removeTag(cell.item.tagGroupId,item.tagId)">&times;</span>
                </div>
                <ng-template [ngIf]="i%3===2"><br /></ng-template>
              </ng-template>
            </ng-template>
          </wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </div>
    <div>
      <h2>タグ一覧</h2>
      <!-- FlexGrid -->
      <wj-flex-grid #dtg_TagList class="right-grid" [itemsSource]="model.tagListForEdit" [allowDragging]="'None'"
        horizontalScrollPolicy="off" [headersVisibility]="'Column'" [selectionMode]="'Row'" verticalScrollPolicy="on"
        [allowSorting]="false" [tabindex]="0">
        <wj-flex-grid-filter #fltr_TagList></wj-flex-grid-filter>
        <!-- column チェックボックス -->
        <wj-flex-grid-column [header]="' '" [width]="40" [binding]="'check'" [align]="'center'" [isReadOnly]="true" [minWidth]="5">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <input type="checkbox" class="selected" [(ngModel)]="cell.item.check" (click)="$event.stopPropagation()"
              [tabindex]="-1" />
          </ng-template>
        </wj-flex-grid-column>
        <!-- column タグ名 -->
        <wj-flex-grid-column [header]="'タグ名'" [width]="604" [binding]="'tagName'" [isReadOnly]="true" [minWidth]="5">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell" [forceFullEdit]="true">
            <input class="grid-text" type="text" plessInputTextSub [fullOnly]="true" [(ngModel)]="cell.item.tagName"
              [maxlength]="30" (change)="updateTagName(cell.item.tagId)" [tabindex]="-1" [restrict]="'[ -￮]'">
          </ng-template>
        </wj-flex-grid-column>
      </wj-flex-grid>

      <div class="element-row btn-area">
        <!-- button タグ集約 -->
        <button #btn_Aggregate id="btn_Aggregate" class="btn-secondary" (click)="aggregateTags()"
          [tabindex]="0">タグ集約</button>
        <!-- button タググループにタグを追加 -->
        <button #btn_AddTags id="btn_AddTags" class="btn-secondary btn-wide" (click)="addTags()"
          [tabindex]="0">タググループにタグを追加</button>
      </div>
    </div>
  </div>
</div>


<footer class="footer-buttons">
  <!-- button 更新 -->
  <button #btn_Modify id="btn_Modify" class="btn-primary" (click)="modify()" [tabindex]="0">更新</button>
</footer>